import * as React from "react";

export default function MaxBoardsReachedStandalone() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="503" height="256" fill="none" viewBox="0 0 503 256">
      <g clipPath="url(#clip0_21955_1451)">
        <path fill="#fff" d="M.33 0h502.01v256H.33z"></path>
        <path fill="#F5B53D" d="M239.77 114.514h61.305v23.134H239.77z"></path>
        <path
          fill="#000"
          d="M251.395 131.062q-1.064 0-1.805-.346a3.35 3.35 0 0 1-1.212-.964 4.2 4.2 0 0 1-.692-1.41 6.6 6.6 0 0 1-.21-1.681v-.693q0-1.248.42-2.25a3.5 3.5 0 0 1 1.286-1.582q.865-.594 2.213-.594 1.335 0 2.2.594a3.4 3.4 0 0 1 1.274 1.582q.42 1.002.42 2.25v.693q0 .877-.222 1.681-.21.791-.68 1.41a3.24 3.24 0 0 1-1.2.964q-.742.346-1.792.346m0-1.607q1.1 0 1.619-.754.52-.767.52-2.374 0-1.706-.532-2.436-.531-.742-1.607-.742-1.089 0-1.632.742-.532.73-.532 2.411 0 1.62.532 2.386.531.767 1.632.767m5.463 1.372v-1.731q0-.569.173-.989.185-.42.593-.742.42-.333 1.1-.63l1.534-.68q.568-.26.865-.631.309-.383.309-.976 0-.655-.396-1.039-.383-.396-1.1-.396t-1.113.396q-.383.396-.383 1.1h-1.694q0-.84.359-1.508a2.54 2.54 0 0 1 1.063-1.063q.705-.396 1.768-.396t1.768.383q.705.384 1.063 1.027.359.63.359 1.409v.161q0 1.014-.569 1.694-.568.667-1.669 1.162l-1.533.68q-.432.185-.606.395-.173.198-.173.544v.792l-.42-.458h5.007v1.496z"
        ></path>
        <path
          fill="#fff"
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M269.287 108.175h156.889v113.106H269.287z"
        ></path>
        <path
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M269.285 101.79v12.77M262.902 108.175h12.77M269.285 214.896v12.771M262.902 221.281h12.77M426.174 214.896v12.771M419.791 221.282h12.77M426.174 101.79v12.77M419.791 108.175h12.77"
        ></path>
        <path fill="#F5B53D" d="M38.502 114.514h106.417v23.134H38.502z"></path>
        <path
          fill="#000"
          d="M50.13 131.062q-1.064 0-1.806-.346a3.36 3.36 0 0 1-1.212-.964 4.2 4.2 0 0 1-.692-1.41 6.6 6.6 0 0 1-.21-1.681v-.693q0-1.248.42-2.25a3.5 3.5 0 0 1 1.286-1.582q.866-.594 2.213-.594 1.335 0 2.2.594a3.4 3.4 0 0 1 1.274 1.582q.42 1.002.42 2.25v.693a6.3 6.3 0 0 1-.222 1.681q-.21.791-.68 1.41a3.25 3.25 0 0 1-1.2.964q-.74.346-1.792.346m0-1.607q1.1 0 1.619-.754.519-.767.519-2.374 0-1.706-.532-2.436-.531-.742-1.607-.742-1.088 0-1.632.742-.531.73-.532 2.411 0 1.62.532 2.386.532.767 1.632.767m6.946 1.372v-7.937l.544.42h-2.387v-1.508h3.586v9.025z"
        ></path>
        <path
          fill="#fff"
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M66.863 108.175h156.889v113.106H66.863z"
        ></path>
        <path
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M66.861 101.79v12.77M60.479 108.175h12.77M66.861 214.896v12.77M60.479 221.281h12.77M223.754 214.896v12.77M217.369 221.281h12.77M223.754 101.79v12.77M217.369 108.175h12.77"
        ></path>
        <path fill="#FFB4C9" d="M280.252 121.454h103.624v59.584H280.252z"></path>
        <mask
          id="mask0_21955_1451"
          width="104"
          height="61"
          x="280"
          y="121"
          maskUnits="userSpaceOnUse"
          style={{ maskType: "alpha" }}
        >
          <path fill="#F5B53D" d="M280.252 121.454h103.624v59.584H280.252z"></path>
        </mask>
        <g stroke="#FF7A53" strokeLinejoin="round" strokeWidth="2.591" mask="url(#mask0_21955_1451)">
          <path d="m280.252 121.454 103.624 59.584M383.877 121.454l-103.624 59.584"></path>
        </g>
        <path
          stroke="#FF7A53"
          strokeLinejoin="round"
          strokeWidth="2.591"
          d="M280.53 197.796h89.375M280.53 206.863h79.013"
        ></path>
        <path fill="#F5B53D" d="M316 29h37v23h-37z"></path>
        <path
          fill="#000"
          d="M327.738 45.466q-1.062 0-1.805-.346a3.35 3.35 0 0 1-1.211-.965 4.2 4.2 0 0 1-.693-1.41 6.6 6.6 0 0 1-.21-1.68v-.693q0-1.248.421-2.25a3.48 3.48 0 0 1 1.285-1.583q.866-.593 2.213-.593 1.336 0 2.201.593a3.4 3.4 0 0 1 1.274 1.583q.42 1.002.42 2.25v.693q0 .878-.223 1.68-.21.792-.68 1.41a3.2 3.2 0 0 1-1.199.965q-.741.346-1.793.346m0-1.607q1.101 0 1.62-.755.519-.766.519-2.373 0-1.707-.531-2.436-.532-.742-1.608-.742-1.088 0-1.632.742-.531.73-.531 2.41 0 1.62.531 2.387.533.767 1.632.767m8.443 1.607q-1.038 0-1.793-.396a2.87 2.87 0 0 1-1.137-1.05 2.85 2.85 0 0 1-.396-1.484h1.694q0 .655.433 1.063.444.396 1.199.396.507 0 .865-.186.372-.198.569-.531.198-.346.198-.792 0-.667-.433-1.088-.432-.432-1.187-.432-.37 0-.655.099a1.8 1.8 0 0 0-.482.26l-.804-1.386 2.967-2.027-.111-.21h-3.882v-1.496h5.897v1.805l-3.053 2.027-.952-.173q.234-.074.507-.111.272-.05.593-.05 1.026 0 1.756.36.741.345 1.137.963.396.619.396 1.422v.16q0 .78-.396 1.435-.396.643-1.137 1.039-.742.383-1.793.383"
        ></path>
        <path
          fill="#fff"
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M307.461 52.653H464.35v113.106H307.461z"
        ></path>
        <path
          stroke="#113357"
          strokeLinejoin="round"
          strokeWidth="2.313"
          d="M307.457 46.268v12.77M301.074 52.653h12.77M307.457 159.374v12.77M301.074 165.759h12.77M464.347 159.374v12.77M457.964 165.759h12.77M464.347 46.268v12.77M457.964 52.653h12.77"
        ></path>
        <path fill="#113357" d="M316.109 98.748h26.535v21.343h-26.535z"></path>
        <path
          fill="#113357"
          d="M353.357 110.147a.62.62 0 0 0 0-.878l-3.951-3.951a.622.622 0 0 0-.878.878l3.512 3.512-3.512 3.512a.62.62 0 1 0 .878.878zm-14.572.182h14.133v-1.242h-14.133zM431.013 110.147a.62.62 0 0 0 0-.878l-3.951-3.951a.622.622 0 0 0-.878.878l3.512 3.512-3.512 3.512a.622.622 0 0 0 .878.878zm-14.572.182h14.133v-1.242h-14.133zM391.032 110.147a.62.62 0 0 0 0-.878l-3.95-3.951a.622.622 0 0 0-.878.878l3.511 3.512-3.511 3.512a.62.62 0 1 0 .878.878zm-14.571.182h14.132v-1.242h-14.132zM366.61 98.322a.62.62 0 0 0 .878 0l3.951-3.95a.622.622 0 0 0-.878-.879l-3.512 3.512-3.512-3.512a.62.62 0 1 0-.878.878zm-.182-14.571v14.132h1.242V83.751z"
        ></path>
        <path fill="#1973FF" d="M353.789 98.748h26.535v21.343h-26.535z"></path>
        <path
          fill="#113357"
          d="M366.61 120.23a.62.62 0 0 1 .878 0l3.951 3.951a.622.622 0 0 1-.878.878l-3.512-3.512-3.512 3.512a.622.622 0 0 1-.878-.878zm-.182 14.571v-14.132h1.242v14.132z"
        ></path>
        <path fill="#FF7A53" d="M430.623 99.477h25.448v20.821h-25.448z"></path>
        <path fill="#1973FF" d="M353.789 68.44h26.535v21.343h-26.535zM353.789 129.057h26.535V150.4h-26.535z"></path>
        <path fill="#FFB4C9" d="m391.457 109.708 15.5-15.5 15.5 15.5-15.5 15.5z"></path>
        <path
          stroke="#FF7A53"
          strokeWidth="1.586"
          d="M109.791 171.774h4.273a7.87 7.87 0 0 0 7.868-7.868v-6.571a7.87 7.87 0 0 1 7.868-7.868h2.681M109.791 171.774h4.273a7.87 7.87 0 0 1 7.868 7.868v6.571a7.87 7.87 0 0 0 7.868 7.868h2.681"
        ></path>
        <path
          stroke="#FFB4C9"
          strokeWidth="1.586"
          d="M159.781 149.468h4.619a7.52 7.52 0 0 0 7.522-7.522 7.52 7.52 0 0 1 7.522-7.522h3.027"
        ></path>
        <path
          stroke="#FFB4C9"
          strokeWidth="1.586"
          d="M159.781 149.468h4.36a7.78 7.78 0 0 1 7.781 7.781 7.78 7.78 0 0 0 7.782 7.782h2.767M161.115 194.081h22.69"
        ></path>
        <path fill="#FF7A53" d="M129.719 136.498h32.774v25.938h-32.774zM129.719 207.05h32.774v-25.938h-32.774z"></path>
        <path
          fill="#FFB4C9"
          d="M178.08 121.454h32.774v25.938H178.08zM178.08 177.999h32.774v-25.938H178.08zM178.08 207.05h32.774v-25.938H178.08z"
        ></path>
        <path fill="#FF7A53" d="M77.832 158.805h32.774v25.938H77.832z"></path>
        <path fill="#fff" d="m305.701 74.029 15.037 8.097v13.88h-15.037z"></path>
        <path
          fill="#00B875"
          d="m279.419 83.2 33.224 7.189-16.7-29.37-3.153 15.62zM220.477 71.774h60.816a5 5 0 0 0 5-5v-21.29a5 5 0 0 0-5-5h-60.816a5 5 0 0 0-5 5v21.29a5 5 0 0 0 5 5"
        ></path>
        <path
          fill="#fff"
          d="M234.442 50.488v7.751q0 1.295-.798 2.077-.798.768-2.107.768-1.324 0-2.122-.783-.798-.798-.798-2.167h1.37q.015.767.391 1.25.391.48 1.159.48t1.144-.45q.376-.468.376-1.175v-7.75zm2.186 6.337q0-1.264.512-2.213a3.7 3.7 0 0 1 1.399-1.49 3.9 3.9 0 0 1 2.002-.526q1.084 0 1.881.466.798.466 1.189 1.174V52.73h1.385v8.247h-1.385v-1.535q-.406.723-1.219 1.204-.798.467-1.866.467-1.099 0-1.987-.542a3.8 3.8 0 0 1-1.399-1.52q-.512-.979-.512-2.227m6.983.015q0-.933-.376-1.626a2.6 2.6 0 0 0-1.023-1.053 2.7 2.7 0 0 0-1.4-.377q-.768 0-1.4.362-.631.36-1.008 1.053-.376.693-.376 1.626 0 .948.376 1.655a2.73 2.73 0 0 0 1.008 1.069q.632.36 1.4.36t1.4-.36q.647-.376 1.023-1.069.376-.707.376-1.64m6.619 4.274q-.948 0-1.7-.316-.753-.33-1.189-.903a2.44 2.44 0 0 1-.482-1.34h1.415q.06.618.572 1.009.526.39 1.369.391.783 0 1.234-.346.452-.346.452-.873a.85.85 0 0 0-.482-.798q-.482-.27-1.49-.526a12 12 0 0 1-1.505-.482 2.9 2.9 0 0 1-.993-.737q-.407-.498-.407-1.295 0-.632.377-1.159.376-.526 1.068-.828.693-.316 1.581-.316 1.37 0 2.212.693.843.691.903 1.896h-1.37a1.4 1.4 0 0 0-.526-1.038q-.467-.392-1.265-.392-.737 0-1.173.316t-.437.828q0 .407.256.677.271.256.662.422.406.15 1.114.346.887.24 1.445.482.557.224.948.692.406.466.421 1.219 0 .678-.376 1.22-.376.54-1.069.857-.677.3-1.565.301m8.541 0a4.26 4.26 0 0 1-2.107-.527 3.83 3.83 0 0 1-1.475-1.49q-.527-.978-.527-2.257 0-1.265.542-2.228a3.77 3.77 0 0 1 1.505-1.49q.948-.526 2.122-.526t2.122.526a3.7 3.7 0 0 1 1.49 1.475q.557.963.557 2.243 0 1.278-.572 2.257a3.87 3.87 0 0 1-1.52 1.49 4.4 4.4 0 0 1-2.137.527m0-1.204a2.9 2.9 0 0 0 1.384-.346q.648-.346 1.039-1.039.406-.692.406-1.685t-.391-1.686-1.024-1.023a2.8 2.8 0 0 0-1.369-.347q-.752 0-1.385.347-.617.33-.993 1.023t-.376 1.686q0 1.008.361 1.7.376.693.993 1.039.618.33 1.355.33m10.048-7.33q1.505 0 2.438.919.933.902.933 2.618v4.861h-1.354v-4.665q0-1.235-.617-1.881-.617-.663-1.686-.663-1.083 0-1.731.678-.632.677-.632 1.971v4.56h-1.369v-8.247h1.369v1.174a2.73 2.73 0 0 1 1.099-.978q.707-.347 1.55-.347"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_21955_1451">
          <path fill="#fff" d="M.33 0h502.01v256H.33z"></path>
        </clipPath>
      </defs>
    </svg>
  );
}
